// much of what is in here comes from https://github.com/visgl/react-google-maps/blob/main/examples/drawing/src/types.ts
import React from "react";
import { useTranslation } from "react-i18next";
import {
  APIProvider,
  ControlPosition,
  Map,
  useApiIsLoaded,
} from "@vis.gl/react-google-maps";
import { API_KEY } from "../../../config/maps";
import errors from "../../../services/errors";

const ACTIVE_ROUTE_MAP_ID = "8cbff7fc95a543f2";

const MapLoader = (props) => {
  const apiIsLoaded = useApiIsLoaded();

  return apiIsLoaded ? props.children : null;
};

const ActiveRoutesBaseLayer = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorBoundary t={t}>
        <APIProvider apiKey={API_KEY}>
          <Map
            mapId={ACTIVE_ROUTE_MAP_ID}
            style={{ width: "100%", height: "100%" }}
            defaultCenter={
              props.defaultCenter ?? { lat: 42.503123, lng: -83.176939 }
            }
            defaultZoom={13}
            disableDefaultUI={true}
            zoomControl={true}
            zoomControlOptions={{
              position: ControlPosition.INLINE_START_BLOCK_END,
            }}
            gestureHandling={"greedy"}
          />

          <MapLoader>{props.children}</MapLoader>
        </APIProvider>
      </ErrorBoundary>
    </>
  );
};

export default ActiveRoutesBaseLayer;
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
  }
  state = { hasError: false, errorId: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error) {
    console.log(error);
    errors
      .report(error)
      .then((id) =>
        this.setState((existing) => ({ ...existing, errorId: id })),
      );
  }

  render() {
    // Class components can't use hooks, so the parent passes t
    const { t } = this.props;
    return this.state.hasError ? (
      <div>
        <h3>{t("activeRoutesMap.errorTitle")}</h3>
        <p>{t("activeRoutesMap.errorHint")}</p>
        <p>{t("activeRoutesMap.errorId", { id: this.state.errorId })}</p>
        <p>
          {t("activeRoutesMap.errorMessage", {
            message: this.state.error.message,
          })}
        </p>
      </div>
    ) : (
      this.props.children
    );
  }
}
